export class ExcludedAgendaAllocationRequestType {
	public index;
	
	constructor(obj) {
		this.index = obj.index;
	}
} 
